export const actionTypes = {
  GET_CONTENT_REQUEST: 'GET_CONTENT_REQUEST',
  GET_CONTENT_SUCCESS: 'GET_CONTENT_SUCCESS',
  GET_CONTENT_FAILURE: 'GET_CONTENT_FAILURE',
  CONNECT_US: 'CONNECT_US',
  CONNECT_US_SUCCESS: 'CONNECT_US_SUCCESS',
  CONNECT_US_FAILURE: 'CONNECT_US_FAILURE',
};
